var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"null-box"},[_c('div',{staticStyle:{"margin-bottom":"40px"}},[_c('img',{staticStyle:{"width":"300px"},attrs:{"src":require("../../imgs/null.png")}}),_c('div',{staticStyle:{"font-size":"22px","font-weight":"600","color":"#B2B9C3"}},[_vm._v("暂无"+_vm._s(_vm.data))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }